var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.26V5.4475C0 5.81583 0.134583 6.13458 0.40375 6.40375L4.14375 10.1438C4.41292 10.4129 4.73167 10.5475 5.1 10.5475C5.45417 10.5475 5.77292 10.4129 6.05625 10.1438L8.90375 7.29625C9.15875 7.02708 9.28625 6.70833 9.28625 6.34C9.28625 5.98583 9.15875 5.66708 8.90375 5.38375L5.16375 1.64375C4.89458 1.37458 4.56875 1.24 4.18625 1.24H1.02C0.736667 1.25417 0.495833 1.35333 0.2975 1.5375C0.113333 1.73583 0.0141667 1.97667 0 2.26ZM2.38 2.94C2.57833 2.94 2.74125 3.00375 2.86875 3.13125C2.99625 3.25875 3.06 3.42167 3.06 3.62C3.06 3.81833 2.99625 3.98125 2.86875 4.10875C2.74125 4.23625 2.57833 4.3 2.38 4.3C2.18167 4.3 2.01875 4.23625 1.89125 4.10875C1.76375 3.98125 1.7 3.81833 1.7 3.62C1.7 3.42167 1.76375 3.25875 1.89125 3.13125C2.01875 3.00375 2.18167 2.94 2.38 2.94Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.52,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.68dd35238646f0e553ddb7f0a9e436c6.svg";
export { ForwardRef as ReactComponent };